module.exports = __webpack_public_path__ + "img/nav-note-active.be53b994.svg";